/* @flow */

import React from 'react';

import type {ColorName} from '../../colors/colors';

import {svgIconWrapper} from '../svg-icon-wrapper';
import Source from './icon-audience-goal.svg';

type Props = {
    color?: ColorName,
};

function SvgComponent(props: Props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Source {...validProps} currentColor={props.color || '#7A7370'} />;
}
SvgComponent.iconName = 'goalAudience';

export const GoalAudienceIcon = svgIconWrapper(SvgComponent);
